import type { Color } from '@/api/types';

/**
 * Tailwind classes for attribution color dots.
 *
 * Hex values mirror the backend `Color` enum
 * (api/src/Domain/Enum/Color.php — getLightHex / getDarkHex).
 * Keep both files in sync when colors change.
 *
 * Classes are literal strings (not built dynamically) so the Tailwind JIT
 * scanner picks them up.
 */
export const COLOR_DOT_CLASSES: Record<Color, string> = {
    blue: 'bg-[#3B82F6] dark:bg-[#60A5FA]',
    green: 'bg-[#10B981] dark:bg-[#34D399]',
    red: 'bg-[#EF4444] dark:bg-[#F87171]',
    purple: 'bg-[#A855F7] dark:bg-[#C084FC]',
    orange: 'bg-[#F97316] dark:bg-[#FB923C]',
    yellow: 'bg-[#EAB308] dark:bg-[#FCD34D]',
    teal: 'bg-[#14B8A6] dark:bg-[#2DD4BF]',
    pink: 'bg-[#EC4899] dark:bg-[#F472B6]',
    indigo: 'bg-[#6366F1] dark:bg-[#818CF8]',
    gray: 'bg-[#6B7280] dark:bg-[#9CA3AF]',
};
